export const customFilterEncode = (filters) => {
  return filters?.filter(f => f.active)?.map(f => {
    return {
      id: f.id,
      value: f.prop?.filter(p => p.value)?.map(p => p.id)?.join(',')
    }
  })
}
